
const sortByTenantIdFn = (tenant_id, subtenantDelimiter = '_') => (a, b) => {
  const [, aSubIndex] = (a.tenant_id ?? tenant_id).split(subtenantDelimiter);
  const [, bSubIndex] = (b.tenant_id ?? tenant_id).split(subtenantDelimiter);
  if (aSubIndex === undefined) return -1;
  if (bSubIndex === undefined) return 1;
  const aSubNumber = Number(aSubIndex);
  const bSubNumber = Number(bSubIndex);
  if (aSubNumber > bSubNumber) return 1;
  return -1;
};

export default sortByTenantIdFn
